module.exports = __webpack_public_path__ + "img/apple-store.0b2f7f8a.svg";